export class ActivityWishlist {
	wishlistId: number;
	token: string;
	status: string;

	guestFirstName: string;
	guestLastName: string;
	guestEmail: string;
	guestPhone: string;

	reservationId: number;
	propertyName: string;
	checkIn: string;
	checkOut: string;
	addressIsland: string;

	itemsJson: string;
	guestNotes: string;
	staffNotes: string;

	sentDate: string;
	viewedDate: string;
	createDate: string;
	lastUpdate: string;
}
